const TOKEN_STORE_KEY = 'dgsk_player_tokens';
const MY_IDENTITY_KEY = 'dgsk_my_identity';

export interface MyIdentity {
    id: string;
    token?: string;
    name: string;
}

export const getMyIdentity = (): MyIdentity | null => {
    try {
        const raw = localStorage.getItem(MY_IDENTITY_KEY);
        return raw ? (JSON.parse(raw) as MyIdentity) : null;
    } catch {
        return null;
    }
};

export const setMyIdentity = (identity: MyIdentity): void => {
    localStorage.setItem(MY_IDENTITY_KEY, JSON.stringify(identity));
};

export const clearMyIdentity = (): void => {
    localStorage.removeItem(MY_IDENTITY_KEY);
};

const getStore = (): Record<string, string> => {
    try {
        return JSON.parse(localStorage.getItem(TOKEN_STORE_KEY) ?? '{}');
    } catch {
        return {};
    }
};

export const storePlayerToken = (playerId: string, token: string): void => {
    const store = getStore();
    store[playerId] = token;
    localStorage.setItem(TOKEN_STORE_KEY, JSON.stringify(store));
};

export const getPlayerToken = (playerId: string): string | null => {
    return getStore()[playerId] ?? null;
};

export const clearPlayerToken = (playerId: string): void => {
    const store = getStore();
    delete store[playerId];
    localStorage.setItem(TOKEN_STORE_KEY, JSON.stringify(store));
};
